export const isTokenExpired = (token: string | null): boolean => {
  if (!token) return true;
  try {
    const payloadBase64 = token.split('.')[1];
    if (!payloadBase64) return true;
    
    // JWT payloads are base64url encoded. Replace chars to make it standard base64
    const base64 = payloadBase64.replace(/-/g, '+').replace(/_/g, '/');
    const decodedJson = atob(base64);
    const decoded = JSON.parse(decodedJson);
    
    const exp = decoded.exp;
    if (!exp) return false; // If no exp claim is present, assume it never expires
    
    // JWT exp is in seconds, Date.now() is in ms
    return Date.now() >= exp * 1000;
  } catch (error) {
    return true; // If decoding fails, assume token is invalid/expired
  }
};
